import { TextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from 'src/pages/manage/security-breach/SecurityBreach';

export const ExtraDetails = () => {
  const { setValue } = useFormContext<FormValues>();
  return (
    <Controller
      name="extraDetails"
      render={({ field, fieldState }) => (
        <TextField
          characterLimit={255}
          id="security-breach-extra-details"
          onChange={field.onChange}
          label="Include a brief description of the issue here and any other details not covered so far."
          secondaryLabel="Optional"
          value={field.value}
          onClear={() => setValue('extraDetails', '')}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
        />
      )}
    />
  );
};
